import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
import { CartStore}  from './commerce/cart.store'
import Animate from '@charrafimed/alpine-animation'
import Zoomable from '@benbjurstrom/alpinejs-zoomable'
import Resize from '@alpinejs/resize'
import { AlpineComponents } from '@nxtlvlsoftware/alpine-typescript'
import { AnnouncementComponent } from "./announcement.component";
import { DrawerComponent } from "./drawer.component";
import { CycleComponent } from "./cycle.component";
import { CarouselComponent } from "./carousel.component";
import { Carousel2Component } from "./carousel2.component";
import { FormComponent }  from "./form.component";
import { FileUploadComponent }  from "./file-upload.component";
import Alpine from 'alpinejs'
import { AlpineWithComponents } from '@nxtlvlsoftware/alpine-typescript/types/Global'
import { ProductSearchComponent }  from './product-search.component'
import { ProductContextComponent }  from './product-context.component'
import { CartItemComponent } from './commerce/cart-item.component'
import anchor from '@alpinejs/anchor';
import { PreferencesStore } from './preferences.store'
import { AnalyticsStore } from './analytics/analytics.store'
import { OrderContactComponent } from './commerce/order-contact.component'
import { NotifierComponent } from './notifier.component'
import { NotificationComponent } from './notification.component'
import { StripeMessagingComponent } from './commerce/stripe-messaging.component'
import { OrderStore } from './commerce/order.store'
import { CheckoutPaymentHandlerComponent } from './commerce/checkout.payment-handler.component'
import { StripeStore } from './commerce/stripe.store'
import { ExpressCheckoutComponent } from './commerce/express-checkout.component'

let alpine = Alpine;

alpine.store('preferences', new PreferencesStore());
alpine.store('analytics', new AnalyticsStore());
alpine.plugin(focus)
alpine.plugin(collapse);
alpine.plugin(intersect);
alpine.plugin(Animate);
alpine.plugin(Zoomable);
alpine.plugin(Resize);
alpine.plugin(anchor);

AlpineComponents.bootstrap({
    components: {
        drawer: DrawerComponent,
        carousel: CarouselComponent,
        carousel2: Carousel2Component,
        cycle: CycleComponent,
        form: FormComponent,
        announcement: AnnouncementComponent,
        productSearch: ProductSearchComponent,
        fileUpload: FileUploadComponent,
        productContext: ProductContextComponent,
        cartItemContext: CartItemComponent,
        checkoutPaymentHandler: CheckoutPaymentHandlerComponent,
        expressCheckout: ExpressCheckoutComponent,
        orderContact: OrderContactComponent,
        notifier: NotifierComponent,
        notification: NotificationComponent,
        stripeMessaging: StripeMessagingComponent
    },
    logErrors: true
}, alpine);

window.Alpine = alpine as AlpineWithComponents;
window.CartObj = CartStore;
window.OrderObj = OrderStore;
window.StripeObj = StripeStore;